import React from "react";
import SubscribeTag from "../SubscriptionBanner";

const Subscription = () => {
  return <SubscribeTag />;
};

export default Subscription;
